import { types, Instance, getParent } from 'mobx-state-tree';
import { TableCell } from '.';

export const TableRow = types.model({
  key: types.identifierNumber,
  cells: types.array(TableCell),
  location: types.maybeNull(types.model({
    formattedAddress: types.maybeNull(types.string),
    locationStatusId: types.maybe(types.number),
    geometry: types.maybeNull(types.model({
      latitude: types.maybeNull(types.number),
      longitude: types.maybeNull(types.number),
    })),
  })),
}).views((self) => ({
  get table() {
    return getParent(self);
  },
  get locationData() {
    return {
      address: self.location?.formattedAddress,
      latitude: self.location?.geometry?.latitude,
      longitude: self.location?.geometry?.longitude,
    };
  },
})).actions((self) => ({
  updateLocation(location: any) {
    self.location = location;
  },
  updateColumnKeys(columnKeys: any) {
    self.cells = columnKeys;
  },
}));

export type ITableRow = Instance<typeof TableRow>;
